<template>
    <b-modal
        id="addressesModal"
        size="lg"
        @hide="clearModal"
        @shown="setMod"
        :hide-header-close="!$store.getters.hasDefaultAddress"
        :no-close-on-esc="!$store.getters.hasDefaultAddress"
        :no-close-on-backdrop="!$store.getters.hasDefaultAddress"
        :title="editMode ? 'Edit ' : 'Create ' + 'shipping address'">
        <address-form :address="address"
                      :submitted-form="submittedForm"
                      ref="addressForm">
            <b-row slot="defaultAddress">
                <b-col>
                    <b-form-checkbox
                        id="checkbox-1"
                        v-model="defaultAddress"
                        :disabled="setDefault || (editMode && address.default)"
                        name="defaultAddress">
                        Default address
                    </b-form-checkbox>
                </b-col>
            </b-row>
        </address-form>
        <template slot="modal-footer">
            <b-btn class="mr-auto text-danger"
                   variant="link"
                   v-if="editMode && !address.default"
                   @click="deleteAddress">Delete
            </b-btn>
            <b-btn class="ml-auto"
                   variant="danger"
                   v-if="$store.getters.hasDefaultAddress"
                   @click="hideModal">Cancel
            </b-btn>
            <b-btn class="ml-auto text-danger"
                   variant="link"
                   v-else
                   @click="$store.commit('LOGOUT')">Logout
            </b-btn>
            <b-btn variant="success"
                   @click="validateForm">{{editMode ? 'Save' : 'Create'}}
            </b-btn>
        </template>
    </b-modal>
</template>

<script>
    import AddressForm from '~cp/UserPanel/Forms/AddressForm'

    export default {
        name: 'AddressesModal',
        components: {
            AddressForm
        },
        props: {
            address: {
                type: Object,
            },
            editMode: {
                type: Boolean,
                required: true
            },
            setDefault: {
                type: Boolean,
            }
        },
        data() {
            return {
                defaultAddress: true,
                addressId: '',
                form: {}
            }
        },
        methods: {
            setMod() {
                if (this.editMode) {
                    this.addressId = this.address.id
                    this.defaultAddress = this.address.default
                }
            },
            validateForm() {
                this.$refs.addressForm.validateForm()
            },
            submittedForm(payload) {
                this.form = {...payload, default: this.defaultAddress}
                if (this.editMode) {
                    this.saveChange()
                } else {
                    this.createAddress()
                }
            },
            saveChange() {
                this.$api('PUT', this.$endpoints.userAddress(this.addressId), this.form).then(() => {
                    this.$emit('updatedAddresses')
                    this.hideModal()
                })
            },
            deleteAddress() {
                this.$api('DELETE', this.$endpoints.userAddress(this.addressId)).then(() => {
                    this.$emit('updatedAddresses')
                    this.hideModal()
                })
            },
            createAddress() {
                this.$api('POST', this.$endpoints.userAddresses, this.form).then(() => {
                    this.$emit('updatedAddresses')
                    this.hideModal()
                })
            },
            clearModal() {
                Object.assign(this.$data, this.$options.data())
                this.defaultAddress = this.setDefault
                this.$validator.reset()
            },
            hideModal() {
                this.$root.$emit('bv::hide::modal', 'addressesModal')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Modals/AddressesModal.vue